export enum Statuses {
  Completed = 'completed',
  HasNotification = 'has-notification',
  InProgress = 'in-progress',
  NotStarted = 'not-started'
}

/**
 * Pass these English strings in to a translation service
 * @example bfTranslate(DefaultStatusLabels.Completed)
 */
export enum DefaultStatusLabels {
  Completed = 'Status: Completed',
  InProgress = 'Status: In Progress',
  NotStarted = 'Status: Not Started'
}
